var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-(Content)",
    transform: "translate(-28.000000, -607.000000)",
    fill: "#06B2BC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(-1.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help",
    transform: "translate(29.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C3.584,6 0,9.584 0,14 C0,18.416 3.584,22 8,22 C12.416,22 16,18.416 16,14 C16,9.584 12.416,6 8,6 Z M8.8,19.6 L7.2,19.6 L7.2,18 L8.8,18 L8.8,19.6 Z M10.456,13.4 L9.736,14.136 C9.336,14.544 9.048,14.912 8.904,15.488 C8.84,15.744 8.8,16.032 8.8,16.4 L7.2,16.4 L7.2,16 C7.2,15.632 7.264,15.28 7.376,14.952 C7.536,14.488 7.8,14.072 8.136,13.736 L9.128,12.728 C9.496,12.376 9.672,11.848 9.568,11.288 C9.464,10.712 9.016,10.224 8.456,10.064 C7.568,9.816 6.744,10.32 6.48,11.08 C6.384,11.376 6.136,11.6 5.824,11.6 L5.584,11.6 C5.12,11.6 4.8,11.152 4.928,10.704 C5.272,9.528 6.272,8.632 7.512,8.44 C8.728,8.248 9.888,8.88 10.608,9.88 C11.552,11.184 11.272,12.584 10.456,13.4 L10.456,13.4 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBlue);
export default __webpack_public_path__ + "static/media/help-blue.cf4a02aca41ce489aacb73c3d3e39d32.svg";
export { ForwardRef as ReactComponent };